import { Table, Form, Alert, Button, Modal, Row, Col } from "react-bootstrap";
import React from "react";

import {
  getColorBasedOnRowData,
  checkForApprovedQtyDiscrepancy,
} from "../../Inventory/common/utils";
import { Textarea } from "@mantine/core";
const userCity = sessionStorage.getItem("userCity") || "";
const userType = sessionStorage.getItem("userType") || "";

const ReceivedQtyTableCell = (props) => {
  const {
    isApprovedQtyFieldsShown,
    overallRouteSummaryDetails,
    setOverallRouteSummaryDetails,
    currentRoute,
    currentSelectedRoute,
    row,
    index,
  } = props;

  if (currentSelectedRoute === "All") {
    if (row.received_qty !== 0 && !row.received_qty) {
      return <td>Not Entered</td>;
    }
    return <td>{row.received_qty}</td>;
  }

  return (
    <td>
      <fieldset disabled={isApprovedQtyFieldsShown}>
        <Form.Control
          type="number"
          defaultValue={row.received_qty}
          onChange={(e) => {
            let val = e.target.value;
            let _routeSumDetails = {
              ...overallRouteSummaryDetails,
            };
            _routeSumDetails[currentRoute][index].received_qty = val;
            setOverallRouteSummaryDetails(_routeSumDetails);
          }}
        />
      </fieldset>
    </td>
  );
};

const ApporvedQtyTableCell = (props) => {
  const {
    isApprovedQtyFieldsShown,
    overallRouteSummaryDetails,
    isApprovedQtyFieldsEditable,
    setOverallRouteSummaryDetails,
    currentRoute,
    currentSelectedRoute,
    row,
    index,
  } = props;

  if (currentSelectedRoute === "All") {
    if (!isApprovedQtyFieldsShown) {
      return "";
    }
    if (
      isApprovedQtyFieldsShown &&
      isApprovedQtyFieldsEditable &&
      !row.approved_qty
    ) {
      return <td>Not Entered</td>;
    }
    return <td>{row.approved_qty}</td>;
  }

  return (
    <>
      {isApprovedQtyFieldsShown ? (
        <td>
          {row.showApprovedQtyField || userType !== "Operation" ? (
            <fieldset disabled={!isApprovedQtyFieldsEditable}>
              <Form.Control
                type="number"
                defaultValue={row.approved_qty}
                onChange={(e) => {
                  let _routeSumDetails = {
                    ...overallRouteSummaryDetails,
                  };
                  _routeSumDetails[currentRoute][index].approved_qty =
                    e.target.value;

                  setOverallRouteSummaryDetails(_routeSumDetails);
                }}
              />
            </fieldset>
          ) : null}
        </td>
      ) : null}
    </>
  );
};

const TransitItemsTableHeader = (props) => {
  const isApprovedQtyFieldsShown = props.isApprovedQtyFieldsShown;

  return (
    <thead className="thead-light">
      <tr>
        <th>Item ID</th>
        <th>Item description || Type || Category</th>
        <th>Sub Category</th>
        <th>Brand</th>
        <th>Shipped Qty</th>
        <th>Received Qty</th>
        <th>Remarks</th>
        {/* {isApprovedQtyFieldsShown ? <th>Approved Qty</th> : null}
        {isApprovedQtyFieldsShown ? <th>Remarks</th> : null} */}
      </tr>
    </thead>
  );
};

const TransitItemsTableBody = ({
  routeProductData,
  overallRouteSummaryDetails,
  setOverallRouteSummaryDetails,
  currentSelectedRoute,
  currentRoute,
  isApprovedQtyFieldsShown,
  isApprovedQtyFieldsEditable,
  showDiscrepancyItemsChecked,
}) => {
  let itemsListData = routeProductData;
  // console.log("check itemsList Data", itemsListData);
  // console.log("check current selected route", currentSelectedRoute);
  let rows = itemsListData.map((row, index) => {
    row.bgColor = getColorBasedOnRowData(
      row,
      isApprovedQtyFieldsEditable,
      isApprovedQtyFieldsShown
    );

    if (
      showDiscrepancyItemsChecked &&
      !checkForApprovedQtyDiscrepancy(
        row,
        isApprovedQtyFieldsEditable,
        isApprovedQtyFieldsShown,
        "transit"
      )
    ) {
      return null;
    }

    return (
      <tr
        key={index}
        style={{ backgroundColor: row.bgColor ? row.bgColor : "" }}
      >
        <td>{row.item_id}</td>
        <td>
          {" "}
          {row.item_disc} || {row.variety} || {row.category}
        </td>

        <td>{row.sub_category}</td>
        <td>{row.brand}</td>
        <td>{row.item_modified_qty}</td>
        <ReceivedQtyTableCell
          isApprovedQtyFieldsShown={isApprovedQtyFieldsShown}
          overallRouteSummaryDetails={overallRouteSummaryDetails}
          setOverallRouteSummaryDetails={setOverallRouteSummaryDetails}
          currentRoute={currentRoute}
          currentSelectedRoute={currentSelectedRoute}
          row={row}
          index={index}
        />

        <td>
          <fieldset disabled={isApprovedQtyFieldsShown}>
            <Textarea
              placeholder="Enter received remarks"
              defaultValue={row.rec_remarks || ""}
              onChange={(e) => {
                let _routeSumDetails = {
                  ...overallRouteSummaryDetails,
                };
                _routeSumDetails[currentRoute][index].rec_remarks =
                  e.target.value;

                setOverallRouteSummaryDetails(_routeSumDetails);
              }}
            />
          </fieldset>
        </td>

        {/* <ApporvedQtyTableCell
          isApprovedQtyFieldsShown={isApprovedQtyFieldsShown}
          overallRouteSummaryDetails={overallRouteSummaryDetails}
          isApprovedQtyFieldsEditable={isApprovedQtyFieldsEditable}
          setOverallRouteSummaryDetails={setOverallRouteSummaryDetails}
          currentRoute={currentRoute}
          currentSelectedRoute={currentSelectedRoute}
          row={row}
          index={index}
        />

        {isApprovedQtyFieldsShown ? (
          <td>
            {row.showApprovedQtyField || userType !== "Operation" ? (
              <fieldset disabled={!isApprovedQtyFieldsEditable}>
                <Textarea
                  placeholder="Enter approved remarks"
                  defaultValue={row.app_remarks || ""}
                  onChange={(e) => {
                    let _routeSumDetails = {
                      ...overallRouteSummaryDetails,
                    };
                    _routeSumDetails[currentRoute][index].app_remarks =
                      e.target.value;

                    setOverallRouteSummaryDetails(_routeSumDetails);
                  }}
                />
              </fieldset>
            ) : null}
          </td>
        ) : null} */}
      </tr>
    );
  });

  return (
    <>
      <tbody>{rows}</tbody>
    </>
  );
};

const TransitItemsTable = ({
  routeProductData,
  overallRouteSummaryDetails,
  currentSelectedRoute,
  currentRoute,
  routeDropDownValues,
  setOverallRouteSummaryDetails,
  removeItemFromSummaryDetails,
  transitID,
  init,
  isApprovedQtyFieldsShown,
  isApprovedQtyFieldsEditable,
  showDiscrepancyItemsChecked,
}) => {
  return (
    <Table striped bordered hover style={{ marginBottom: "30px" }}>
      <TransitItemsTableHeader
        isApprovedQtyFieldsShown={isApprovedQtyFieldsShown}
      />
      <TransitItemsTableBody
        routeProductData={routeProductData}
        overallRouteSummaryDetails={overallRouteSummaryDetails}
        currentRoute={currentRoute}
        currentSelectedRoute={currentSelectedRoute}
        setOverallRouteSummaryDetails={setOverallRouteSummaryDetails}
        removeItemFromSummaryDetails={removeItemFromSummaryDetails}
        init={init}
        transitID={transitID}
        isApprovedQtyFieldsEditable={isApprovedQtyFieldsEditable}
        isApprovedQtyFieldsShown={isApprovedQtyFieldsShown}
        showDiscrepancyItemsChecked={showDiscrepancyItemsChecked}
      />
    </Table>
  );
};

export default TransitItemsTable;
